import * as React from 'react'

function SvgFunArrowLeft(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M16 20a.997.997 0 01-.707-.293l-7-7a.999.999 0 010-1.414l7-7a.999.999 0 111.414 1.414L10.414 12l6.293 6.293A.999.999 0 0116 20" />
    </svg>
  )
}

export default SvgFunArrowLeft
